import { Link, NavLink, useNavigate } from "react-router-dom";
import { Sparkles, LogIn, LayoutDashboard, ShieldCheck, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import HeaderSearch from "@/components/HeaderSearch";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header data-testid="site-header" className="fixed top-0 inset-x-0 z-50 pt-4 px-4">
      <div className="glass-strong max-w-6xl mx-auto flex items-center gap-3 px-5 py-3">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2.5 font-semibold tracking-tight shrink-0">
          <span className="relative w-8 h-8 rounded-lg overflow-hidden">
            <span className="absolute inset-0 bg-gradient-to-br from-violet-500 via-cyan-400 to-fuchsia-500" />
            <span className="absolute inset-[3px] rounded-md bg-[#0a0a10]" />
            <span className="absolute inset-[6px] rounded-sm bg-gradient-to-br from-violet-500 to-cyan-400" />
          </span>
          <span className="text-lg hidden sm:inline">
            PixelEmpire <span className="text-neon-cyan text-xs font-mono align-middle">AI</span>
          </span>
        </Link>

        <div className="hidden md:block flex-1 max-w-xs">
          <HeaderSearch />
        </div>

        <nav className="hidden lg:flex items-center gap-1 text-sm font-medium">
          {[
            ["Grid", "/#explore"],
            ["Pricing", "/pricing"],
            ["How it works", "/how-it-works"],
            ["Directory", "/directory"],
            ["Blog", "/blog"],
            ["FAQ", "/faq"],
          ].map(([label, to]) => (
            <a
              key={label}
              href={to}
              data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className="px-3 py-2 rounded-full hover:bg-white/5 transition-colors whitespace-nowrap"
            >
              {label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 ml-auto shrink-0">
          {user ? (
            <>
              <NavLink to="/dashboard" data-testid="nav-dashboard" className="btn-ghost hidden sm:inline-flex">
                <LayoutDashboard className="w-4 h-4" /> Dashboard
              </NavLink>
              {user.role === "admin" && (
                <NavLink to="/admin" data-testid="nav-admin" className="btn-ghost hidden sm:inline-flex">
                  <ShieldCheck className="w-4 h-4" /> Admin
                </NavLink>
              )}
              <button
                data-testid="logout-btn"
                onClick={async () => { await logout(); navigate("/"); }}
                className="btn-ghost"
              >
                <LogOut className="w-4 h-4" />
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="login-link" className="btn-ghost">
                <LogIn className="w-4 h-4" /> Log in
              </Link>
              <Link to="/register" data-testid="register-link" className="btn-primary">
                <Sparkles className="w-4 h-4" /> Get started
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
